class TruncatedContent extends HTMLElement {
  constructor() {
    super()
    this._onResize = this._checkOverflow.bind(this)
  }

  connectedCallback() {
    const lines = this.getAttribute('lines') || '2'
    this.style.setProperty('--truncated-content-lines', lines)

    this._content = this.querySelector('[slot="content"]')
    this._toggle = this.querySelector('[slot="toggle"]')
    if (!this._content || !this._toggle) return

    this._checkOverflow()
    window.addEventListener('resize', this._onResize)
    this._toggle.addEventListener('click', this._onToggleClick)
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize)
    if (this._toggle) {
      this._toggle.removeEventListener('click', this._onToggleClick)
    }
  }

  _checkOverflow() {
    const hasOverflow = this._content.scrollHeight > this._content.clientHeight
    this.classList.toggle('has-overflow', hasOverflow)
  }

  _onToggleClick = () => {
    const isExpanded = this.classList.toggle('is-expanded')
    this._toggle.setAttribute('aria-expanded', isExpanded)
  }
}

customElements.define('truncated-content', TruncatedContent)
